export default "__VITE_ASSET__5a8c5f5e__"